import * as React from 'react';
import {Conduit, TargetType, Graft} from "./TriggerClasses";

class PlannerButton extends React.PureComponent < {
    title : Conduit | TargetType,
    selected : boolean,
    onClick : Function,
    addConduit : Function,
    hasactions : boolean,
    rightcolumn : boolean,
    rootGraft : Graft,
    customText: string,
    context: string,
    customTextChanged: Function, 
    ymenuEnabled: boolean
    disabled: boolean
}, {
    showymenu: boolean,
    shouldOpenUpwards: boolean,
    yTypeSelected: string,
    isediting: boolean 
} > {

    constructor(props: any) {
        super(props);
        this.state = {
           
            showymenu: false,
            shouldOpenUpwards: false,
            yTypeSelected: "SEQ",
            isediting: false
        };
    }
    componentDidMount = () => {}
    bottomLocationMenu: number = 0;
    buttonClicked = (e: any) => {
       
if (this.props.title === TargetType.CUSTOM)
{ 
    if (!this.props.selected)
    {
    this.setState({
      isediting: true,
    // overridevalue: valueIn 
    });
    e.stopPropagation();
    }else
    {
        this
        .props
        .onClick(e, "CUSTOM");
    }

}else
{
//TIG-26: If it is being toggled and it is currently selected then reset showymenu.
    if (this.props.selected)
    {
    this.setState({
        showymenu: false

    });
    }
        this
            .props
            .onClick(e, this.props.title);
                
}
    }

    blurValue = (e: any) =>
    {
     this.setState({
       isediting: false
     })
     this.props.customTextChanged(this.props.title, e.target.value);
    }

    showYMenu = (e:any) => {
        let menuShown = this.state.showymenu;
        let shouldOpenUpwards = false;

        //document.getElementById("HeartDrawingOverlay").getBoundingClientRect().y

        if (document.getElementsByClassName("heart-image-container").length > 0 && this.props.context !== "QuickDefinitions")
        {
        if (e.currentTarget.getBoundingClientRect().bottom + 200 > document.getElementsByClassName("heart-image-container")[0].getBoundingClientRect().bottom) {
            shouldOpenUpwards = true;
            // let buttonOffset = 0;
            // if ((document.getElementsByClassName("overlay-buttons")[0] as HTMLElement).style.paddingBottom)
            //     buttonOffset = parseInt((document.getElementsByClassName("overlay-buttons")[0] as HTMLElement).style.paddingBottom);
            //     let MarginOffset = 0;
            //     if (e.currentTarget.style.marginBottom)
            //         MarginOffset = parseInt(e.currentTarget.style.marginBottom)
            this.bottomLocationMenu = (document
                .getElementsByClassName("heart-image-container")[0] as HTMLElement)
                .getBoundingClientRect()
                .bottom - e
                .currentTarget
                .getBoundingClientRect()
                .bottom + 50;
        }
        }
        this.setState({
            showymenu: !menuShown,
            shouldOpenUpwards: shouldOpenUpwards

        });
    }
    addConduit = (e: any) => {
        let conduitFound = "";
        conduitFound = e.currentTarget.id;
        this
            .props
            .addConduit(this.props.title, conduitFound, this.state.yTypeSelected);
        this.setState({showymenu: false, shouldOpenUpwards: false});
    }
    yGraftTypeSelected = (yType: string) =>
    {
      this.setState({
        yTypeSelected: yType

    });

    }

    seqGraftTypeSelected = (targetType: string) =>
    {
        let conduitFound = "";
       // conduitFound = conduitType;
        this
            .props
            .addConduit(this.props.title, conduitFound, "SEQ", targetType);
      this.setState({
        yTypeSelected: "SEQ",
        showymenu: false, 
        shouldOpenUpwards: false

    });

    }
    static defaultProps = {
        title: "BUTTON",
        hasactions: false,
        rightcolumn: false,
        context: "Planner",
        ymenuEnabled: true, 
        disabled: false,
        addConduit: () => {}
    }

    recurseTargetsForGivenTarget = (graftIn: Graft, childTargetName: string, returnParentMode: boolean, parentName: string): string | null =>
    {
        if (graftIn.type === "Target" && graftIn.name === childTargetName)
        {
            if (returnParentMode)
            {
return parentName;
            }else
            {
            if (graftIn.conduit)
                return graftIn.conduit;
            else
                return "SEQ";
            }
        }
        if (graftIn.targets && graftIn.targets.length > 0)
        {
        for (let index = 0; index < graftIn.targets.length; index++) {
            const element = graftIn.targets[index];
            let conduitInput = this.recurseTargetsForGivenTarget(element, childTargetName, returnParentMode, graftIn.name as string);
            if (conduitInput)
            {
                return conduitInput;
            }
        }
            }
    return null;
    }
    

    //Seq search should check if there are any targets at all (Ignore the source and the current target).
recurseTargetsForYConduits = (rootGraft: Graft, childTargetName: String, seqSearch?: boolean, toIgnore?: string)=>
{
    let yConduitsAtLevel: string[] = [];
//If it's not sequential then any target is possible  except toignore.


if (!seqSearch)
{
    if (rootGraft.name || rootGraft.title) 
    {
    if (toIgnore !== rootGraft.name && toIgnore !== rootGraft.title && rootGraft.type !== "Source")
    {
        //No duplicates.
        if (yConduitsAtLevel.indexOf(rootGraft.name ? rootGraft.name as string : rootGraft.title as string) === -1)
            yConduitsAtLevel.push(rootGraft.name ? rootGraft.name as string : rootGraft.title as string);
    }
    }
        if (rootGraft.targets) {
            for (let index = 0; index < rootGraft.targets.length; index++) {
                const graftChild = rootGraft.targets[index];
                let yChildren = this.recurseTargetsForYConduits(graftChild, childTargetName, seqSearch, toIgnore)
               for (let indexYChild = 0; indexYChild < yChildren.length; indexYChild++) {
                   const element = yChildren[indexYChild];
                   //No duplicates.
                   if (yConduitsAtLevel.indexOf(element) === -1)
                    yConduitsAtLevel.push(element);
                   
               }
          
              }
        }
   
}

if (seqSearch)
{

if (rootGraft.name || rootGraft.title) 
{
  if (rootGraft.targets) {
    let DoesContainChild  = false;
    for (let index = 0; index < rootGraft.targets.length; index++) {
      const graftChild = rootGraft.targets[index];
        if (graftChild.name === childTargetName)
        {
          DoesContainChild = true;
        }
    }
    DoesContainChild = false;
    //If the child target is a direct child of the current node then it is not a Y source.
    if (!DoesContainChild)
    {
        //If we are doing a seq search then ignore the source and the target itself.
        //Also make sure it is not the child of it's parent.
        if ((!seqSearch && toIgnore !== rootGraft.name && toIgnore !== rootGraft.title) || (seqSearch && rootGraft.type !== "Source" && childTargetName !== rootGraft.name))
            yConduitsAtLevel.push(rootGraft.name ? rootGraft.name as string : rootGraft.title as string);
    }
}
}

  if (rootGraft.targets) {
    for (let index = 0; index < rootGraft.targets.length; index++) {
        const graftChild = rootGraft.targets[index];

        //Then every graft with at least one target is a potential y source.
        if (graftChild.targets && graftChild.targets.length > 0) {

        if (graftChild.name) 
        {
            //Comment below seems to now longer apply?
        //if it is the parent of the current one item then ignore it as a Y source because it is same as SEQ. HAAKON???? This is wrong.
        yConduitsAtLevel = yConduitsAtLevel.concat(this.recurseTargetsForYConduits(graftChild, childTargetName, seqSearch, toIgnore));
        }
        }
        else
        {
            if (seqSearch && graftChild.name && childTargetName !== graftChild.name) 
            {
                //For loose searches for sequential the target does not need to be a source.
                yConduitsAtLevel = yConduitsAtLevel.concat(this.recurseTargetsForYConduits(graftChild, childTargetName, seqSearch, toIgnore));
            }
        }

        }
    
}
}
return yConduitsAtLevel;

}

customTargetEditClicked =() =>
{
    //Display input in the button and set focus to it.
}


    render() {

        if (this.props.hasactions) {
            let conduitButtons = [];
            for (let conduitItem in Conduit) {
                // conduitButtons.push(<PlannerButton title={conduitItem as Conduit}
                // selected={this.state.theplan.filter((item)=> { return item.Conduit ===
                // conduitItem }).length > 0} onClick={this.conduitToggled}></PlannerButton>);

                //Håkon: should a Y be available from the original source conduit. -> Yes
                //If it is selected let's highlight it. What is the current Conduit in use?
                conduitButtons.push(
                    <a key={conduitItem}
                        href="/#"
                        className={"basic-button graft-type " + (conduitItem === this.recurseTargetsForGivenTarget(this.props.rootGraft, this.props.title, false, "") ? " graft-type-switch-on" : "")}
                        onClick={this.addConduit}
                        id={conduitItem}>{conduitItem}</a>
                );
            }
           
            let ySources = ["SEQ"];
            let ySourcesButtons = [];
          

            let seqSelected = this.recurseTargetsForGivenTarget(this.props.rootGraft, this.props.title, true, "");
            ySources = ySources.concat(this.recurseTargetsForYConduits(this.props.rootGraft, this.props.title, false, this.props.title));

            let seqSources: string[] = [];
            let seqSourcesButtonsInContainer = [];
            seqSources = seqSources.concat(this.recurseTargetsForYConduits(this.props.rootGraft, this.props.title, true, seqSelected as string));
           
            //PROP: Proposed change: Need another source of extensions where a new conduit can be selected.

 //Generate SEQ options
 for (let index = 0; index < seqSources.length; index++) {
    const element = seqSources[index];
 
      seqSourcesButtonsInContainer.push(
        <a key={element}
        href="/#"
        className={"basic-button graft-type " + (element === seqSelected ? " graft-type-switch-on" : "")}
        onClick={() => { this.seqGraftTypeSelected(element); }}
      >{element === "CUSTOM"? this.props.customText : element}</a>
    );
}
if (this.state.yTypeSelected === "SEQ")
{
    //This is where we may need to check if any sources should be shown.
    conduitButtons = seqSourcesButtonsInContainer;
}
  
            for (let index = 0; index < ySources.length; index++) {
                const element = ySources[index];
               
                let IsYGraft = " Y";
                if (element === "SEQ") 
                  IsYGraft = "";
                ySourcesButtons.push(
                    <a href="/#" key={element} className={"basic-button graft-type-switch " + (this.state.yTypeSelected === element ? "graft-type-switch-on " : "") + (this.props.rightcolumn ? "" : "graft-type-switch-left")} onClick={()=>{this.yGraftTypeSelected(element)}}>{element === "CUSTOM"? this.props.customText : element}{IsYGraft}</a>
                );
            }
        
          
    }


        

        let contentsOfButton: React.ReactElement = <span>{this.props.title}</span>;
        if (this.props.title === "CUSTOM")
        {
            if (this.state.isediting)
            {
                contentsOfButton= <input className="pebble-button-input" type="text" autoFocus={true} defaultValue={this.props.customText} onBlur={this.blurValue} />;
            }
            else
            {
                if (this.props.customText)
                {
                    //If the button is the CUSTOM target show an edit icon instead.
                //The edit icon needs an on click event to start editing it.
                contentsOfButton = <span onClick={this.customTargetEditClicked}>{this.props.customText}</span>;
                }else
                {
                //If the button is the CUSTOM target show an edit icon instead.
                //The edit icon needs an on click event to start editing it.
                contentsOfButton = <a href="/#" onClick={this.customTargetEditClicked}><i className="material-icons pebble-button-con-edit">edit</i></a>;
                }
            }
         

       
        }



        return (

            <li  onClick={this.buttonClicked} className={(this.props.context === "QuickDefinitions" ? "quarter-space" : "")+ " worklist-frequently-used-item third-space target-" + this.props.title + 
            (this.props.selected
                ? " pebble-button-selected"
                : "")+ (this.props.disabled
                    ? " saved"
                    : "")}>{contentsOfButton}</li>
        );
    }

}

export default PlannerButton;